<template>
  <div class="legend-container">
    <p
      v-if="description"
      class="mb-2 text-body-3"
    >
      {{ description }}
    </p>
    <div
      v-for="({ mood, description: itemDescription }, i) in items"
      :key="mood"
      class="d-flex align-center justify-start"
      :class="{ 'mb-2': i !== items.length - 1 }"
    >
      <ActionableInsightIcon
        :mood="mood"
        class="mr-2"
      />
      <p class="text-body-3 text-textLight">
        {{ itemDescription }}
      </p>
    </div>
  </div>
</template>

<script>
import ActionableInsightIcon from './ActionableInsightIcon.vue';

export default {
  name: 'ActionableInsightLegend',
  components: {
    ActionableInsightIcon,
  },
  props: {
    description: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default() {
        return [];
      },
      validator: (items) => items.every((item) => item.description && item.mood),
    },
  },
};
</script>

<style lang="less" scoped>
.legend-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start
}
</style>
